export default __webpack_public_path__ + "static/media/footer.18667549.jpg";